import CaptureOrganizationSettings from "./CaptureOrganizationSettings";

enum CaptureSettingsAction {
    Capture = "capture",
    Notify = "notify",
    NoAction = "no-action"
}

interface Capture {
    action: CaptureSettingsAction.Capture;
    organizations: CaptureOrganizationSettings[];
}

interface Notify {
    action: CaptureSettingsAction.Notify;
    notificationMessage?: string;
}

interface NoAction {
    action: CaptureSettingsAction.NoAction;
}

type CaptureSettings = Capture | Notify | NoAction;

export default CaptureSettings;

export {
    CaptureSettingsAction,
    Capture,
    Notify,
    NoAction
};
